(function () {
'use strict';
var d = document, w = window;
var reduce = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
var CFG = w.AWX || {};
CFG.open = CFG.open || 8; CFG.close = CFG.close || 18;
CFG.openLabel = CFG.openLabel || '8 AM'; CFG.closeLabel = CFG.closeLabel || '6 PM';
CFG.tz = CFG.tz || 10;
var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
function $all(sel, scope) { return Array.prototype.slice.call((scope || d).querySelectorAll(sel)); }
function guamNow() { var n = new Date(); return new Date(n.getTime() + n.getTimezoneOffset() * 60000 + CFG.tz * 3600000); }
function parseDays(s) { return String(s || '0,1,2,3,4,5,6').split(',').map(function (x) { return parseInt(x, 10); }); }
function statusFor(days) {
var g = guamNow(), day = g.getDay(), hr = g.getHours() + g.getMinutes() / 60;
var openDay = days.indexOf(day) > -1;
if (openDay && hr >= CFG.open && hr < CFG.close) return { open: true, text: 'Open now · until ' + CFG.closeLabel, short: 'Open now' };
if (openDay && hr < CFG.open) return { open: false, text: 'Closed · opens today at ' + CFG.openLabel, short: 'Opens ' + CFG.openLabel };
for (var i = 1; i <= 7; i++) {
var dd = (day + i) % 7;
if (days.indexOf(dd) > -1) {
return { open: false, text: 'Closed · opens ' + (i === 1 ? 'tomorrow' : DAYS[dd]) + ' at ' + CFG.openLabel, short: i === 1 ? 'Opens tomorrow' : 'Opens ' + DAYS[dd].slice(0, 3) };
}
}
return { open: false, text: 'Closed', short: 'Closed' };
}
function paintStatus(scope) {
var anyOpen = false;
var all = CFG.shops || { a: [0, 1, 2, 3, 4, 5, 6] };
Object.keys(all).forEach(function (k) { if (statusFor(all[k]).open) anyOpen = true; });
$all('[data-awx-days]', scope).forEach(function (el) {
var st = statusFor(parseDays(el.getAttribute('data-awx-days')));
var dot = el.querySelector('.awx-dot'); if (dot) dot.classList.toggle('is-open', st.open);
var t = el.querySelector('[data-awx-status-text]');
if (t) t.textContent = el.hasAttribute('data-short') ? st.short : st.text;
});
$all('[data-awx-now]', scope).forEach(function (el) {
var dot = el.querySelector('.awx-dot'); if (dot) dot.classList.toggle('is-open', anyOpen);
var t = el.querySelector('[data-awx-status-text]');
if (t) t.textContent = anyOpen ? 'Open now · ' + CFG.openLabel + '–' + CFG.closeLabel : 'Closed now · shops open at ' + CFG.openLabel;
});
}
var FB = { book: 'Schedule', ac_check: 'Schedule', call: 'Contact', whatsapp: 'Contact', plan: 'Lead', subscribe: 'Lead', directions: 'FindLocation' };
function track(ev, data) {
data = data || {};
var payload = { event: 'awx_' + ev };
Object.keys(data).forEach(function (k) { payload[k] = data[k]; });
try { (w.dataLayer = w.dataLayer || []).push(payload); } catch (e) {}
try { if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === 'function') w.Shopify.analytics.publish('awx_' + ev, data); } catch (e) {}
try { if (typeof w.fbq === 'function' && FB[ev]) w.fbq('track', FB[ev], { content_name: ev, awx_location: data.awx_location || '' }); } catch (e) {}
try { var to = CFG.gads && CFG.gads[ev]; if (to && typeof w.gtag === 'function') w.gtag('event', 'conversion', { send_to: to }); } catch (e) {}
}
function kindOf(a) {
var k = a.getAttribute('data-awx-track');
if (k) return k;
var h = (a.getAttribute('href') || '').toLowerCase();
if (h.indexOf('tel:') === 0) return 'call';
if (h.indexOf('wa.me/') > -1 || h.indexOf('whatsapp.com') > -1) return 'whatsapp';
if (h.indexOf('shopmonkey.cloud/public/scheduler') > -1) return 'book';
if (h.indexOf('shopmonkey.cloud/public/quote-request') > -1) return 'quote';
if (h.indexOf('google.com/maps') > -1) return 'directions';
return null;
}
d.addEventListener('click', function (e) {
var a = e.target.closest ? e.target.closest('a,button[data-awx-track]') : null;
if (!a || a.getAttribute('aria-disabled') === 'true') return;
var k = kindOf(a);
if (!k) return;
track(k, { awx_location: a.getAttribute('data-awx-loc') || '', awx_placement: a.getAttribute('data-awx-place') || '', link_url: a.href || '', page_type: d.body.classList.contains('awx-home') ? 'home' : 'page' });
}, true);
var top = d.querySelector('[data-awx-top]');
var dock = d.querySelector('[data-awx-dock]');
var isHome = d.body.classList.contains('awx-home');
if (dock && !isHome) dock.classList.add('is-on');
function setMenu(open) {
var mega = d.querySelector('[data-awx-mega]');
if (!mega) return;
mega.classList.toggle('is-open', open);
$all('[data-awx-menu-toggle]').forEach(function (b) {
b.setAttribute('aria-expanded', String(open));
if (b.hasAttribute('data-label-open')) b.setAttribute('aria-label', open ? b.getAttribute('data-label-close') : b.getAttribute('data-label-open'));
});
}
d.addEventListener('click', function (e) {
var t = e.target.closest ? e.target.closest('[data-awx-menu-toggle]') : null;
var mega = d.querySelector('[data-awx-mega]');
if (t) { e.preventDefault(); setMenu(!(mega && mega.classList.contains('is-open'))); return; }
if (mega && mega.classList.contains('is-open')) {
var inside = e.target.closest && e.target.closest('[data-awx-mega]');
var link = e.target.closest && e.target.closest('[data-awx-mega] a');
if (!inside || link) setMenu(false);
}
});
d.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
var plx = [];
var ticking = false;
function onScroll() {
var y = w.pageYOffset || d.documentElement.scrollTop || 0;
if (top) top.classList.toggle('is-scrolled', y > 40);
if (dock && isHome) dock.classList.toggle('is-on', y > 360);
if (!reduce) {
var vh = w.innerHeight;
plx.forEach(function (el) {
var r = el.getBoundingClientRect();
if (r.bottom < -100 || r.top > vh + 100) return;
var f = parseFloat(el.getAttribute('data-awx-parallax')) || 0.12;
el.style.transform = 'translate3d(0,' + ((r.top + r.height / 2 - vh / 2) * -f).toFixed(1) + 'px,0)';
});
}
ticking = false;
}
w.addEventListener('scroll', function () { if (!ticking) { ticking = true; w.requestAnimationFrame(onScroll); } }, { passive: true });
var io = (!reduce && 'IntersectionObserver' in w && d.documentElement.classList.contains('awx-motion')) ? new IntersectionObserver(function (entries) {
entries.forEach(function (en) {
if (!en.isIntersecting) return;
en.target.classList.add('is-in');
if (typeof en.target._awxIn === 'function') { en.target._awxIn(); en.target._awxIn = null; }
io.unobserve(en.target);
});
}, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' }) : null;
function whenSeen(el, cb) {
if (cb) el._awxIn = cb;
if (io) io.observe(el);
else { el.classList.add('is-in'); if (cb) cb(); }
}
function countUp(el) {
var to = parseFloat(el.getAttribute('data-awx-count'));
var from = parseFloat(el.getAttribute('data-from') || '0');
var pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '';
if (!io || isNaN(to)) return;
el.textContent = pre + from + suf;
whenSeen(el, function () {
var t0 = null, dur = parseInt(el.getAttribute('data-dur') || '1300', 10);
function step(ts) {
if (!t0) t0 = ts;
var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
el.textContent = pre + Math.round(from + (to - from) * e) + suf;
if (p < 1) w.requestAnimationFrame(step);
}
w.requestAnimationFrame(step);
});
}
function initReport(rep) {
var steps = $all('[data-step]', rep), boxes = $all('input[type=checkbox]', rep);
var btn = rep.querySelector('[data-awx-approve]'), later = rep.querySelector('[data-awx-later]'), reset = rep.querySelector('[data-awx-reset]');
var head = rep.querySelector('[data-awx-done-head]'), txt = rep.querySelector('[data-awx-done-text]');
function setStep(cur) { steps.forEach(function (s, i) { s.classList.toggle('is-done', i < cur); s.classList.toggle('is-now', i === cur); }); }
function count() {
var n = boxes.filter(function (b) { return b.checked; }).length;
if (btn) { btn.disabled = n === 0; btn.textContent = n === 0 ? 'Tick what you approve' : 'Approve ' + n + (n === 1 ? ' item' : ' items'); }
}
boxes.forEach(function (b) { b.addEventListener('change', count); });
function done(approved) {
rep.classList.add('is-sent');
if (head) head.textContent = approved ? 'Sent to your service advisor' : 'Saved for later';
if (txt) txt.textContent = approved ? 'Work starts only on what you ticked. We text you when your car is ready.' : 'Nothing is done without your OK. These items stay on your report.';
boxes.forEach(function (b) { b.disabled = true; });
if (approved) setStep(3);
}
if (btn) btn.addEventListener('click', function () { done(true); });
if (later) later.addEventListener('click', function () { done(false); });
if (reset) reset.addEventListener('click', function () {
rep.classList.remove('is-sent');
boxes.forEach(function (b, i) { b.disabled = false; b.checked = i === 0; });
count(); setStep(2);
});
count();
if (!io) { setStep(2); rep.classList.add('is-play'); return; }
setStep(-1);
whenSeen(rep, function () {
rep.classList.add('is-play');
var k = 0;
(function next() { setStep(k); if (k < 2) { k++; setTimeout(next, 520); } })();
});
}
function initBook(bk) {
var svcBtns = $all('[data-svc]', bk), shopBtns = $all('[data-shop]', bk);
var cta = bk.querySelector('[data-awx-cta]'), ctaLabel = bk.querySelector('[data-awx-cta-label]'), ctaArrow = bk.querySelector('[data-awx-cta-arrow]');
var note = bk.querySelector('[data-awx-note]');
var n1 = bk.querySelector('[data-awx-n1]'), n2 = bk.querySelector('[data-awx-n2]');
var state = { svc: null, shop: null };
function svcBtn() { return state.svc ? bk.querySelector('[data-svc=' + state.svc + ']') : null; }
function render(pop) {
var sb = svcBtn();
var mode = sb ? (sb.getAttribute('data-mode') || 'book') : 'book';
bk.setAttribute('data-mode', mode);
var allowed = sb && sb.getAttribute('data-shops') ? sb.getAttribute('data-shops').split(',') : null;
svcBtns.forEach(function (b) { b.setAttribute('aria-pressed', String(b === sb)); });
shopBtns.forEach(function (b) {
var id = b.getAttribute('data-shop');
var ok = !allowed || allowed.indexOf(id) > -1;
b.disabled = !ok;
b.setAttribute('aria-pressed', String(ok && state.shop === id));
var live = b.querySelector('[data-live]'), off = b.querySelector('[data-off]');
if (live) live.hidden = !ok;
if (off) { off.hidden = ok; off.textContent = (sb && sb.getAttribute('data-off')) || 'Not available here'; }
});
$all('[data-alt]', bk).forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-alt') === mode); });
var shopB = state.shop ? bk.querySelector('[data-shop=' + state.shop + ']') : null;
var ready = mode === 'book' && !!sb && !!shopB && !shopB.disabled;
if (n1) n1.classList.toggle('is-done', !!sb);
if (n2) n2.classList.toggle('is-done', !!shopB && !shopB.disabled);
if (note) { var nt = sb ? (sb.getAttribute('data-note') || '') : ''; note.textContent = nt; note.hidden = !nt; }
if (!cta) return;
if (ready) {
cta.setAttribute('href', shopB.getAttribute('data-url'));
cta.removeAttribute('aria-disabled');
cta.setAttribute('data-awx-loc', state.shop);
cta.setAttribute('target', '_blank');
if (ctaLabel) ctaLabel.textContent = 'See open times at ' + shopB.getAttribute('data-name');
if (ctaArrow) ctaArrow.hidden = false;
if (pop) { cta.classList.remove('is-ready'); void cta.offsetWidth; cta.classList.add('is-ready'); }
} else {
cta.setAttribute('href', '#awx-book');
cta.setAttribute('aria-disabled', 'true');
cta.removeAttribute('target');
if (ctaLabel) ctaLabel.textContent = !sb && !shopB ? 'Pick a service and a shop' : (!sb ? 'Now pick a service' : 'Now pick a shop');
if (ctaArrow) ctaArrow.hidden = true;
}
}
svcBtns.forEach(function (b) {
b.addEventListener('click', function () {
state.svc = b.getAttribute('data-svc');
var allowed = b.getAttribute('data-shops') ? b.getAttribute('data-shops').split(',') : null;
if (allowed) {
if (allowed.length === 1) state.shop = allowed[0];
else if (state.shop && allowed.indexOf(state.shop) === -1) state.shop = null;
}
render(true);
track('select_service', { awx_service: state.svc });
});
});
shopBtns.forEach(function (b) {
b.addEventListener('click', function () {
if (b.disabled) return;
state.shop = b.getAttribute('data-shop');
b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
render(true);
});
});
if (cta) cta.addEventListener('click', function (e) {
if (cta.getAttribute('aria-disabled') === 'true') {
e.preventDefault();
var first = !state.svc ? svcBtns[0] : shopBtns.filter(function (x) { return !x.disabled; })[0];
if (first) first.focus();
}
});
render(false);
bk.addEventListener('awx:pick', function (e) {
var o = e.detail || {}, b = o.svc ? bk.querySelector('[data-svc="' + o.svc + '"]') : null;
if (!b) return;
state.svc = o.svc;
var al = b.getAttribute('data-shops'); al = al ? al.split(',') : null;
if (al && al.length === 1) state.shop = al[0]; else if (al && state.shop && al.indexOf(state.shop) < 0) state.shop = null;
render(true);
});
try { var want = sessionStorage.getItem('awx-pick'); if (want) { sessionStorage.removeItem('awx-pick'); bk.dispatchEvent(new CustomEvent('awx:pick', { detail: JSON.parse(want) })); } } catch (x) {}
}
function initHero(hero) {
var g = guamNow(), h = g.getHours() + g.getMinutes() / 60;
var phase = (h >= 6 && h < 18) ? 'day' : (h >= 18 && h < 19.5 ? 'dusk' : 'night');
hero.classList.add('is-' + phase);
var wx = hero.querySelector('.wx');
if (!wx || reduce) return;
if (phase === 'night') {
for (var i = 0; i < 28; i++) {
var s = d.createElement('span'); s.className = 'star';
s.style.left = (Math.random() * 100).toFixed(1) + '%'; s.style.top = (Math.random() * 65).toFixed(1) + '%';
s.style.animationDelay = (Math.random() * 3.4).toFixed(2) + 's';
wx.appendChild(s);
}
}
var chip = hero.querySelector('[data-awx-weather]');
if (!chip || !w.fetch) return;
var LABEL = function (c) {
if (c === 0) return 'clear'; if (c <= 2) return 'partly cloudy'; if (c === 3) return 'cloudy';
if (c === 45 || c === 48) return 'foggy'; if (c >= 51 && c <= 57) return 'drizzle'; if (c >= 61 && c <= 67) return 'rain';
if (c >= 80 && c <= 82) return 'rain showers'; if (c >= 95) return 'thunderstorms'; return '';
};
w.fetch('https://api.open-meteo.com/v1/forecast?latitude=13.49&longitude=144.78&current=temperature_2m,weather_code,precipitation&temperature_unit=fahrenheit&timezone=Pacific%2FGuam')
.then(function (r) { return r.ok ? r.json() : null; })
.then(function (j) {
if (!j || !j.current) return;
var c = j.current, code = c.weather_code, lbl = LABEL(code);
chip.textContent = ' · Tamuning ' + Math.round(c.temperature_2m) + '°F' + (lbl ? ', ' + lbl : '');
chip.hidden = false;
var wet = (code >= 51 && code <= 67) || (code >= 80 && code <= 82) || code >= 95 || (c.precipitation || 0) > 0;
if (wet) {
hero.classList.add('is-rain');
for (var k = 0; k < 46; k++) {
var dr = d.createElement('span'); dr.className = 'drop';
dr.style.left = (Math.random() * 100).toFixed(1) + '%';
dr.style.height = (10 + Math.random() * 16).toFixed(0) + 'px';
dr.style.animationDuration = (0.55 + Math.random() * 0.5).toFixed(2) + 's';
dr.style.animationDelay = (-Math.random() * 1.2).toFixed(2) + 's';
wx.appendChild(dr);
}
}
}).catch(function () {});
}
function init(scope) {
paintStatus(scope);
$all('[data-awx-stagger]', scope).forEach(function (g) {
Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); });
});
$all('[data-awx-reveal],[data-awx-inview]', scope).forEach(function (el) { whenSeen(el); });
$all('[data-awx-count]', scope).forEach(countUp);
$all('[data-awx-report]', scope).forEach(initReport);
$all('[data-awx-book]', scope).forEach(initBook);
$all('[data-awx-hero]', scope).forEach(initHero);
plx = $all('[data-awx-parallax]');
onScroll();
}
if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); });
else init(d);
d.addEventListener('shopify:section:load', function (e) { init(e.target); });
setInterval(function () { paintStatus(d); }, 60000);
w.AWXTrack = track;
})();